
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton } from '@/components';
import { TableAction, TableColumn, TableColumnType } from '@/components/table/types';
import { useActivity } from '@/modules/activity/model/list';
import { ROUTE_NAME_ACTIVITY } from '@/modules/activity/router';
import { TaskOption } from '@/modules/activity/model/mixins';

export default defineComponent({
    name: ROUTE_NAME_ACTIVITY.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton },
    setup() {
        const { query, v$, list, total, fetchList } = useActivity();

        const columns: TableColumn[] = [
            { type: TableColumnType.Index, label: '#' },
            { type: TableColumnType.Text, label: 'Account ID', key: 'accountId' },
            { type: TableColumnType.Text, label: 'Name', key: 'accountName' },
            { type: TableColumnType.Text, label: 'Feature', key: 'feature' },
            { type: TableColumnType.Option, label: 'Task', key: 'action', options: TaskOption },
            { type: TableColumnType.DateTime, label: 'Date/Time', key: 'createTime' },
            { type: TableColumnType.Actions, label: 'Actions' }
        ];

        const actions: TableAction[] = [
            {
                props: row => ({
                    icon: 'fa-eye',
                    theme: 'info',
                    tooltip: 'Detail',
                    to: { name: ROUTE_NAME_ACTIVITY.DETAIL, params: { id: row.id } }
                })
            }
        ];

        const table = { columns, actions };

        onMounted(fetchList);

        return { query, list, v$, total, table, fetchList, TaskOption };
    }
});
